import { useCallback } from "react";
import { useHistory } from "react-router-dom";

import { type WorkBadgeReviewPolicySource } from "../../WorkBadges/components/Policy/types";
import { WorkBadgeReviewPolicyStep } from "../../WorkBadges/hooks/useWorkBadgeReviewPolicy";
import { getWorkBadgeReviewPolicyUrl } from "../../WorkBadges/utils/getWorkBadgeReviewPolicyUrl";
import { useIsBadgeVerificationClockInEnabled } from "../../WorkerShifts/ShiftDetails/components/BadgeVerification/hooks/useIsBadgeVerificationClockInEnabled";
import { useWorkplaceBadge } from "../../Workplace/hooks/useWorkplaceBadge";
import { BaseIndependentContractorBadgeRequiredCard } from "./BaseIndependentContractorBadgeRequiredCard";
import { BaseWorkBadgeRequiredCard } from "./BaseWorkBadgeRequiredCard";

interface BaseWorkBadgeRequiredCardContainerProps {
  analyticsMetadata: Record<string, string | boolean | undefined>;
  source: WorkBadgeReviewPolicySource;
  shiftId: string;
  qualification: string;
  workplaceId: string | undefined;
  // Props for legacy card
  state: string;
}

export function BaseWorkBadgeRequiredCardContainer(props: BaseWorkBadgeRequiredCardContainerProps) {
  const { analyticsMetadata, source, shiftId, qualification, state, workplaceId } = props;

  const history = useHistory();

  const { isEnforced: isWorkplaceBadgeEnforced, isLoading: isWorkplaceBadgeLoading } =
    useWorkplaceBadge(workplaceId);
  const isBadgeVerificationClockInEnabled = useIsBadgeVerificationClockInEnabled();

  const handleReviewPolicy = useCallback(() => {
    history.replace(
      getWorkBadgeReviewPolicyUrl({
        source,
        shiftId,
        qualificationName: qualification,
        step: WorkBadgeReviewPolicyStep.REVIEW_POLICY,
      })
    );
  }, [history, source, shiftId, qualification]);

  if (isWorkplaceBadgeLoading) {
    return null;
  }

  if (isBadgeVerificationClockInEnabled && isWorkplaceBadgeEnforced) {
    return (
      <BaseWorkBadgeRequiredCard
        analyticsMetadata={analyticsMetadata}
        onReviewPolicy={handleReviewPolicy}
      />
    );
  }

  return (
    <BaseIndependentContractorBadgeRequiredCard
      history={history}
      shiftId={shiftId}
      state={state}
      qualification={qualification}
      analyticsMetadata={analyticsMetadata}
    />
  );
}
